import * as React from "react"

const SvgConsentThreeAOneTwo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 967 1326"
  >
    <defs>
      <pattern
        id="New_Pattern_Swatch_8"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="translate(-5018 1284)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <clipPath id="clip-path">
        <path
          d="M262.93,390.11s52.87,40.54,68.32,75.08c17.17,38.39,37.45,56.27,42.28,95.46,6.91,56.15,12.78,68.08,18.63,125,7.33,71.22,11.95,99.94,20.91,132.17,0,0-62.37,15.95-111.36,16-85.3,0-96.07-31.31-96.07-31.31,3.34-38.83,2.13-61.31,2.88-144.09.65-71.25,3.7-93.6,8.16-168.89C218.86,452.72,218.67,407.31,262.93,390.11Z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      style={{
        isolation: "isolate",
      }}
    >
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M454.59,531c132.77,35.93,234-39.46,299.83-115.41,57.75-66.59,76.32-152.91,89.9-240C858.59,84,901.34,40,962,1.14V.5H0V814.78S186.58,458.5,454.59,531Z"
          fill="#351377"
        />
        <path
          d="M667,1.5S469,113.29,463,317.4c-3.47,118.21-61.79,176.35-110.26,204.34A271.74,271.74,0,0,1,452.59,530c132.77,35.93,234-39.46,299.83-115.41,57.75-66.59,76.32-152.91,89.9-240C856.58,83.09,899.25,39.07,959.82.26Z"
          fill="#2b1266"
        />
      </g>
      <g id="Layer_8" data-name="Layer 8">
        <path
          d="M348.37,260.36c-2.87-.34-5,2.14-6.22,4.46-.68,1.32-1.23,2.73-2,4a8.29,8.29,0,0,1-3.37,2.95,27.69,27.69,0,0,1-4.56,1.67q-2.49.74-5,1.22a49.13,49.13,0,0,1-10.41.8c-3.57-.1-7.11-.56-10.68-.67a24.27,24.27,0,0,0-9.47,1.16,7.55,7.55,0,0,0-5.06,5.72c-.54,3,.13,6.12-1.2,9-1.4,3-4.09,5.42-6.65,7.47s-5.92,4-9.5,3.78c-.64,0-.64,1,0,1a13.49,13.49,0,0,0,8.33-2.68,31.6,31.6,0,0,0,6.76-6.09,14.12,14.12,0,0,0,2.21-3.64,12.68,12.68,0,0,0,.78-4.31c.1-2.92-.1-6.08,2.45-8.08,2.39-1.87,5.77-2.21,8.69-2.31,3.57-.12,7.12.31,10.67.54a51.86,51.86,0,0,0,20.61-2.64,15.09,15.09,0,0,0,4.27-2.12,10.35,10.35,0,0,0,2.88-3.8c1.29-2.62,2.89-6.84,6.53-6.4.64.07.64-.93,0-1Z"
          fill="#351377"
        />
      </g>
      <g id="Layer_13" data-name="Layer 13">
        <g>
          <path
            d="M644.11,1180.83c1,11.46,1.45,25.48-1.45,36.78-.39,1.51-.82,3-1.22,4.46h.16c5.36,1.1,10.85,1.09,16.3,1.13s10.9.44,16.37.64c3.22.11,6.45.09,9.67,0l1.23-5.12c1.46-33.76,17.9-86.26,17.9-135.75,0-80.14-23.86-89-21.64-168.26.25-9,2.8-15.21,5.5-23.74H599.18c5.73,22.1,5.88,36.77,6.45,50.09,1.74,41,13.35,52,13.35,52C637.7,1071.65,637.44,1101.34,644.11,1180.83Z"
            fill="#d69b6d"
          />
          <path
            d="M619.38,992.37A36.66,36.66,0,0,0,652,988.66c.75-.49-.06-1.61-.8-1.12A35.22,35.22,0,0,1,620,991.12c-.82-.31-1.4.94-.57,1.25Z"
            fill="#bc835a"
          />
          <g>
            <rect
              x={642.77}
              y={1227.5}
              width={50.88}
              height={36.09}
              transform="translate(-582.37 1904.31) rotate(-89.57)"
              fill="#305387"
            />
            <path
              d="M553.55,1299.83h0a18.15,18.15,0,0,1,16-17.88h0a73.54,73.54,0,0,0,59.61-45.68l10.24-25.54a2.68,2.68,0,0,1,4-1.23l4.14,2.81a17,17,0,0,1,7.45,14.18l-.21,27.36a12.74,12.74,0,0,0,12.63,12.84h0a12.75,12.75,0,0,0,12.83-12.64l.21-28.13a8.31,8.31,0,0,1,8.38-8.26l2.69,0a.85.85,0,0,1,.85.85s5,11.51,3.49,74.08c-.06,2.32-4.28,8.26-4.28,8.26l-35.15,1-2.92-5.91-32.89,9.57-61.15-.46Z"
              fill="#a9c9c3"
            />
            <path
              d="M553.55,1299.83l60.71.45a73.6,73.6,0,0,0,21.37-3l7.72-2.26a66.84,66.84,0,0,1,19.27-2.68l33.24.25a1.33,1.33,0,0,1,1.32,1.34l0,2.55a13.1,13.1,0,0,1-13.19,13l-28.17-.21a2.57,2.57,0,0,1-2.54-2.56v-3.19a1.7,1.7,0,0,0-2.17-1.63l-14.49,4.14a83.12,83.12,0,0,1-23.31,3.16l-50.89-.38a8.94,8.94,0,0,1-8.86-9Z"
              fill="#305387"
            />
          </g>
        </g>
      </g>
      <g id="People">
        <g>
          <g>
            <path
              d="M265.62,1210.81l56.94.67c-6.12,32.07,9.25,64.39,9.25,64.39l-53.44-2.61-8.94-9.87A127.78,127.78,0,0,0,265.62,1210.81Z"
              fill="#dba795"
            />
            <g>
              <path
                d="M423.47,1300.15l-160.06-1.86a84.65,84.65,0,0,1,4.57-33.93,1.47,1.47,0,0,1,1.65-.95l69.25,12.5a3.09,3.09,0,0,0,3.34-1.73,3.15,3.15,0,0,0-1.18-3.92l-16.71-11.08a3,3,0,0,1-1.36-2.39,2.89,2.89,0,0,1,4-2.74l40.86,17c13.84,5.51,30.34,14.54,44.86,17.88C421.7,1291,423.49,1298.5,423.47,1300.15Z"
                fill="#f4e2ca"
              />
              <path
                d="M319.31,1272.38h0a22.41,22.41,0,0,1,6.43-12.27h0l15.39,10.2a3.08,3.08,0,0,1-2.25,5.6Z"
                fill="#281a24"
              />
              <path
                d="M423.42,1304.15l.05-4-160.06-1.86-.09,7.64c0,1.56,1.7,2.84,3.84,2.86l147.3,1.71C419.37,1310.56,423.38,1307.71,423.42,1304.15Z"
                fill="#281a24"
              />
            </g>
          </g>
          <path
            d="M374.26,789.93c-5,31-4.68,72-10.3,127.09-3.18,31.26-11.68,74.74-14.53,120.41-6.31,101.28-8,130.69-21.26,174,0,0-8.85,2.93-33.13,2.93-20,0-32.09-2.5-32.09-2.5-16.19-76.13-15.42-140.27-15.27-218.94.19-93.91-27.61-151.29-12.53-203.52Z"
            fill="url(#New_Pattern_Swatch_8)"
          />
          <path
            d="M333.53,1211c-38.86,13.71-79.79-1.46-79.79-1.46l-1.76-28a307.76,307.76,0,0,0,44.75,4.34c19.43.22,40.93-2.77,40.93-2.77Z"
            fill="#382632"
          />
          <path
            d="M262.73,979s3.24,61.9,0,86.46"
            fill="none"
            stroke="#281a24"
            strokeMiterlimit={10}
            opacity={0.35}
          />
        </g>
      </g>
      <g id="eyes">
        <path
          d="M624.52,384.93c-6.11-9.56-19.85-16.19-30.44-9.86a5.59,5.59,0,0,0-1,.76,4.64,4.64,0,0,0-3.25,3.3c-1.74,5.8-6.18,9.79-6.6,16.18-.36,5.54,1.1,12.73,4.09,17.47A9.58,9.58,0,0,0,593,417c3.38.77,6-1.37,9.28-1.15,6.86.45,12,7.5,18.64,1.66C629.69,409.77,630.65,394.52,624.52,384.93Z"
          fill="#dbc3a1"
        />
        <path
          d="M591,672.44s33.22.91,48.57.89c14.36,0,57.34-1.22,57.34-1.22,15.32,27.62,9.54,94.87,10.53,103.2,8.24,69.43-24.35,80-20.31,159.86,0,0-10-5.71-40.59-5.71-23.11,0-46.86,5.26-46.86,5.26C601.9,875.77,571.22,790.76,591,672.44Z"
          fill="#694c51"
        />
        <path
          d="M571.33,800.29a178.91,178.91,0,0,0,35.77,52c14.75,14.85,32.81,29.49,53.34,35.68,11.74,3.53,24.49,4,36.24.27a3.9,3.9,0,0,0,2.73-4.36l-.85-4.74a3.89,3.89,0,0,0-4.93-3c-18.29,5-39.57-2.73-54-12.8a168.59,168.59,0,0,1-40.56-40.13,164.08,164.08,0,0,1-16.1-28c-3.31-7.29-15-2.26-11.62,5.07Z"
          fill="#382632"
        />
        <path
          d="M637.52,426.82c-8.54,3.86-37.31,23.12-37.31,23.12-15.74,17.83-19.74,32-24.27,49.42-6.38,24.58-7.7,68.61-7.73,85.17-.05,25.44-3.07,47.24-2.57,70.75,1.16,54.86-8.43,141.64-8.43,141.64,10,8.29,46.08,3.74,82,7.36,55,5.52,86.42-7.36,86.42-7.36-3-17.2-10.42-79.83-6.34-149.27,6.34-107.87-11.54-182.9-33.7-217C685.63,430.6,655.68,418.6,637.52,426.82Z"
          fill="#13a89e"
        />
        <path
          d="M600.33,685.07c-12.67,33.31-23.22,54.6-33.86,71.3-2.12,3.32-12.06,12.85-12.3,25.85-.36,18.76,11.22,35.92,15.61,33.87.65-.3,4.27-2.88,6.38-9.75,3.29-10.71,11.87-12.17,14.45-18.75,4.9-12.48,2.81-18.87,4.52-24.12,4.38-13.44,22.52-36.83,39.38-65.17C625.44,691.65,612,684.51,600.33,685.07Z"
          fill="#d69b6d"
        />
        <path
          d="M600.21,449.94c.3-1.78,15.48-18.81,15.71-20.61,4.55-35-4-73.41-4-73.41l49-.72,7,52,.16,1.2c32.15,31.13,50.24,81.49,30.6,88.57-10.11,3.64-17.4,1.63-42.56-13.44l-49.37-12.31Z"
          fill="#d69b6d"
        />
        <path
          d="M616.25,385.79l.38,5c23.79.06,33.25-28.2,33.25-28.2C641.69,364.3,616.25,385.79,616.25,385.79Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M656.45,338.78c0-.17-1.72-5.86-1.76-8.26C654.24,300,635,278,611.92,275.92c-14.59-1.28-25.13-1.71-31.42,6-5.28,6.47-7.42,19.81-7.78,32.12-.33,11.45-5.44,16.27-10.4,22.21a3.54,3.54,0,0,0,3.64,5.54l4-.44a1.69,1.69,0,0,1,1.85,1.42A80.63,80.63,0,0,0,578,364.49c6.37,13.5,14.39,25.65,35.54,21.86,23.51-4.21,37.67-25.91,42.67-33.8A109.68,109.68,0,0,0,656.45,338.78Z"
          fill="#d69b6d"
        />
        <path
          d="M586.4,326.38a2.41,2.41,0,1,1-2.38-2.81A2.63,2.63,0,0,1,586.4,326.38Z"
          fill="#382632"
        />
        <path
          d="M582,280.06a38.72,38.72,0,0,1,23.9-25c.83-.29.47-1.62-.37-1.33a40.13,40.13,0,0,0-24.86,25.93.69.69,0,0,0,1.33.37Z"
          fill="#e8d1b5"
        />
        <path
          d="M601.16,919.92c13-4.74,27.77-5,41.49-5.74,14.46-.78,29-.38,43,3.48a.69.69,0,0,0,.37-1.33c-14.16-3.9-28.81-4.32-43.4-3.53-13.82.74-28.73,1-41.85,5.79-.83.3-.48,1.64.36,1.33Z"
          fill="#5b3f45"
        />
        <path
          d="M689.76,806.2q-.25,10.51-.51,21a3.7,3.7,0,0,0,.81,3,7.6,7.6,0,0,0,3.09,1.49,79,79,0,0,0,9.83,2.59c.87.17,1.24-1.17.36-1.34a77.64,77.64,0,0,1-8.37-2.11c-1.19-.37-3.05-.68-3.91-1.62s-.39-3.43-.36-4.71l.45-18.33a.7.7,0,0,0-1.39,0Z"
          fill="#5b3f45"
        />
        <path
          d="M634.89,699.4c1.27.8,2.68,1.41,4,2.1l4,2.08c1.54.82,3.09,1.64,4.62,2.48a25.35,25.35,0,0,1,2.81,1.63c.72.53,1.41-.67.7-1.19a25.43,25.43,0,0,0-2.81-1.64c-1.53-.84-3.08-1.66-4.63-2.47q-2-1-4-2.08c-1.34-.69-2.75-1.31-4-2.11-.75-.47-1.45.72-.69,1.2Z"
          fill="#19bcac"
        />
        <path
          d="M591.33,789.66l67.91,2.06c21.78.65,42.45-.48,63.33-7.24.84-.27.48-1.61-.37-1.33-21.61,7-43.05,7.79-65.54,7.11l-65.33-2c-.89,0-.89,1.36,0,1.38Z"
          fill="#19bcac"
        />
        <path
          d="M633.29,590.89a29.26,29.26,0,0,1,19.61,8.63.69.69,0,0,0,1-1,30.8,30.8,0,0,0-20.59-9c-.89,0-.89,1.35,0,1.39Z"
          fill="#19bcac"
        />
        <path
          d="M608.43,664.17c4.71-.15,9.51,1.7,13.9,3.24a113.87,113.87,0,0,1,13.48,5.7c6.3,3.15,13.1,6.95,18.16,12a.69.69,0,0,0,1-1,60.77,60.77,0,0,0-6.52-5.1,77.93,77.93,0,0,0-12.68-7.46,119.13,119.13,0,0,0-13-5.47c-4.52-1.58-9.41-3.44-14.27-3.29a.7.7,0,0,0,0,1.39Z"
          fill="#19bcac"
        />
        <path
          d="M570,550.6a443.33,443.33,0,0,0,68.15,5.82.7.7,0,0,0,0-1.39,439.64,439.64,0,0,1-67.78-5.76c-.87-.15-1.25,1.18-.37,1.33Z"
          fill="#f9f5ec"
        />
        <path
          d="M569.27,567.53c10.82,1.71,21.63,3.67,32.49,5.07,11.35,1.46,22.89,1.07,34.3,1.12a.69.69,0,0,0,0-1.38c-11-.05-22.16.33-33.12-1-11.14-1.33-22.22-3.41-33.3-5.17-.87-.13-1.25,1.2-.37,1.34Z"
          fill="#f9f5ec"
        />
        <path
          d="M639,556.32c18.22,4,36.65,8,55.39,7.11.85,0,.86-1.42,0-1.38-18.63.88-36.93-3.06-55-7.07-.83-.18-1.19,1.15-.35,1.34Z"
          fill="#f9f5ec"
        />
        <path
          d="M636.58,573.53c9.41,2.63,18.88,5.16,28.41,7.28,9.1,2,18.11,1.83,27.36,1.27.87-.05.87-1.44,0-1.38-9.48.58-18.63.71-28-1.44s-18.35-4.52-27.46-7.06a.69.69,0,0,0-.36,1.33Z"
          fill="#f9f5ec"
        />
        <path
          d="M699.81,562.83a109.39,109.39,0,0,0,18.88-.89c.76-.1.77-1.48,0-1.38a109.39,109.39,0,0,1-18.88.89c-.78,0-.78,1.35,0,1.38Z"
          fill="#f9f5ec"
        />
        <path
          d="M697.58,581.68a94.84,94.84,0,0,0,22.08-.51c.77-.1.77-1.49,0-1.38a94.84,94.84,0,0,1-22.08.51c-.78-.08-.77,1.31,0,1.38Z"
          fill="#f9f5ec"
        />
        <path
          d="M600.33,683.58c12.27-28.24,24.6-56.68,31.88-86.54a225.07,225.07,0,0,0,6.2-41.74c.87-16.77,1-33.91,12.44-47.71.51-.62-.4-1.5-.91-.88-8.06,9.75-11,21.24-12,33.43-1.48,17.21-2,34.09-5.7,51.09-7,31.85-20.14,62.07-33.16,92-.32.73.93,1,1.25.33Z"
          fill="#19bcac"
        />
        <path
          d="M651.35,707.3c2.51-16.77,5.3-33.85,13.77-49,8.66-15.46,19.44-29.35,24.3-46.48,4.74-16.71,7.36-33.78,9-51,1.7-18,5.54-36,.87-53.9a.69.69,0,0,0-1.33.35c4.75,18.2.66,36.68-1.06,55s-4.52,36.94-10.41,54.5c-5.69,16.94-18.06,30.58-25.57,46.67-6.38,13.67-8.69,28.78-10.9,43.47-.12.83,1.21,1.19,1.34.35Z"
          fill="#19bcac"
        />
        <path
          d="M656.45,483.51a39,39,0,0,1,13.08-7.05c5-1.57,10.55-2.36,15.67-.8a.7.7,0,0,0,.37-1.34c-5.34-1.62-11.17-.83-16.41.8a40.94,40.94,0,0,0-13.69,7.41c-.69.57.3,1.54,1,1Z"
          fill="#894e46"
        />
        <path
          d="M578.49,789.8c-7.93,5-10.6,14.47-11,23.33,0,.89,1.35.89,1.39,0,.35-8.35,2.8-17.41,10.29-22.13.75-.48.06-1.67-.7-1.2Z"
          fill="#bc835a"
        />
        <path
          d="M564.59,789.66a26.06,26.06,0,0,0-2.83,8.47c-.62,3-1.21,6.12-.34,9.15a.69.69,0,0,0,1.33-.37c-.82-2.88-.19-5.84.4-8.7a24.48,24.48,0,0,1,2.63-7.86.69.69,0,0,0-1.19-.69Z"
          fill="#bc835a"
        />
        <path
          d="M556.3,787.34a18.31,18.31,0,0,0-.53,6.21.71.71,0,0,0,.69.7.69.69,0,0,0,.69-.7,17,17,0,0,1,.49-5.85.69.69,0,0,0-1.34-.36Z"
          fill="#bc835a"
        />
        <ellipse
          cx={583.54}
          cy={352.7}
          rx={5.59}
          ry={3.02}
          transform="translate(-58.51 123.15) rotate(-11.48)"
          fill="#fff"
        />
        <path
          d="M604.17,444.45s58.13-.72,78.48-19.33c0,0,21.28,23.18,25.81,63.78l-7,9.68L670.64,501,629,490.5l-34-16-1.59-16.12S604.33,444.4,604.17,444.45Z"
          fill="#13a89e"
        />
        <path
          d="M719.74,378.72c-2.79-4.28-6.35-7.87-7.6-13-1.19-4.88-.6-10.08-.31-15,.62-10.51-1.4-19.19-4.57-29.14a50.58,50.58,0,0,1-2.64-15.76c0-5.62.5-11.23-.21-16.83-1-8.06-4.65-16.22-11.79-20.63-3.32-2.06-8.45-2.08-11.24-4.74-1.55-1.47-2.32-4.14-3.41-5.95a30.16,30.16,0,0,0-4-5.2,34.41,34.41,0,0,0-23.6-10.17,35.91,35.91,0,0,0-14,2.79c-6.1,2.29-11.33,1.24-17.63.6-10.41-1.05-21.49,0-29.93,6.73a29.64,29.64,0,0,0-11.14,21.51,5.17,5.17,0,0,0-.33,1.68c-.33,8.54,5.54,15.45,12.72,19.38,8.64,4.74,19.23,4.57,27.64,9.66,3.21,2,6.81,5.2,6.75,9.28-.06,4.34-2.07,7.72.67,11.84,2.06,3.1,6.33,3.41,8.34,6.07s-1.14,9.45-1,12.72c.43,9.11,9.41,13.16,11.61,21.25,1.31,4.81-.37,10-1.26,14.76A52.59,52.59,0,0,0,642,396.1c.86,8.08,1.73,20.88,9.6,25.49,6.39,3.75,14.82,1.5,20.53-2.5,7.84-5.5,11.72-13.69,22.4-13.5,8.19.16,17.09,1.7,24-3.88C726,395.72,724.46,385.94,719.74,378.72Z"
          fill="#dbc3a1"
        />
        <path
          d="M595.53,390.71c-2.64,1.43-2.53,4.86-1.67,7.32.55,1.56,1.43,3.14,1.49,4.83,0,1.27-.36,2.87-1.68,3.38-.89.34-.5,1.79.4,1.44,2.92-1.11,3.16-4.59,2.32-7.18-.53-1.61-1.45-3.2-1.59-4.91a3.56,3.56,0,0,1,1.48-3.59c.85-.46.1-1.75-.75-1.29Z"
          fill="#e8ceaf"
        />
        <path
          d="M607.39,396.44c-1.28,2.21-.67,4.75-.16,7.1.4,1.89.69,4.33-1,5.71-.74.62.32,1.67,1.06,1.06,1.73-1.43,1.87-3.82,1.58-5.89-.32-2.33-1.5-5-.21-7.23a.75.75,0,0,0-1.3-.75Z"
          fill="#e8ceaf"
        />
        <path
          d="M601.33,276.93c-.17,4.8,4.32,7.73,8.2,9.49,5.62,2.54,11.67,4.22,17.16,7.05,2.47,1.28,4.81,3,5.88,5.69s.83,5.57.66,8.33a25.62,25.62,0,0,0,.33,8.15,16,16,0,0,0,2.93,5.57c2.65,3.43,6.2,6.1,8.61,9.71a10.12,10.12,0,0,1,1.9,5.75c0,2.85-1.29,5.49-1.12,8.38.58,10.11,10.17,16.89,12.25,26.57,2.58,12-4.13,24.77,1.73,36.21.44.86,1.74.1,1.3-.76-5.18-10.11-.08-21.88-1.09-32.57-.48-5.1-2.55-9.48-5.26-13.76s-5.88-8.34-7.06-13.24a16.15,16.15,0,0,1,.28-7.66,11.68,11.68,0,0,0-.13-6.73c-1.38-3.82-4.57-6.67-7.32-9.52a29.84,29.84,0,0,1-4.18-5.14,13.81,13.81,0,0,1-1.83-7.44c0-5.17,1.35-10.83-2.28-15.18a18.25,18.25,0,0,0-6.91-4.62c-3.15-1.37-6.39-2.58-9.58-3.85-4.52-1.81-13.19-4.19-13-10.43,0-1-1.47-1-1.5,0Z"
          fill="#e8ceaf"
        />
        <path
          d="M642.71,273.23c6.58,4.86,13.6,10.19,17.33,17.68,2.13,4.26,2.43,8.72,2.35,13.4-.07,4.47,0,8.94,2.11,13,1.8,3.4,4.54,6.16,6.76,9.29a18.1,18.1,0,0,1,2.63,5,15.47,15.47,0,0,1,.22,7.16c-.38,2.33-.94,4.63-1.1,7a18.24,18.24,0,0,0,.86,6.64c1.43,4.59,3.87,8.8,5.46,13.34a72.05,72.05,0,0,1,3.38,33.24c-.12.94,1.32,1.35,1.45.4a73.84,73.84,0,0,0-2-29.51,103.21,103.21,0,0,0-5.37-14,25.94,25.94,0,0,1-2.24-7.18,25.13,25.13,0,0,1,.62-7.58c.83-4.41,1.15-8.53-1-12.62-1.84-3.5-4.7-6.31-6.94-9.54a18,18,0,0,1-2.72-5.55,28.55,28.55,0,0,1-.67-7.72c0-4.62.11-9.13-1.63-13.5-3.51-8.76-11.42-14.8-18.77-20.23-.78-.57-1.53.73-.76,1.3Z"
          fill="#e8ceaf"
        />
        <path
          d="M697.61,355.84c-1.94,6.56,2.69,12.86,4.37,19a41.7,41.7,0,0,1,.25,21c-.23.94,1.21,1.34,1.44.4a43.17,43.17,0,0,0,.19-20.06,64.73,64.73,0,0,0-3.36-9.64c-1.31-3.26-2.48-6.74-1.45-10.25a.75.75,0,0,0-1.44-.4Z"
          fill="#e8ceaf"
        />
        <path
          d="M581.81,309.88c0-1.93.83-2.37,3.48-1.82a20.42,20.42,0,0,1,7.4,3.69c4.5,3.59,6.71,9.94,5.56,8.55a30.56,30.56,0,0,0-9.52-8.05C586,310.78,581.8,310.33,581.81,309.88Z"
          fill="#513715"
        />
        <path
          d="M324.79,420.68s-29.2-6.82-36.27,2.69C268.29,450.63,369.44,541,369.44,541,368.75,496.33,343.53,432.92,324.79,420.68Z"
          fill="#a02410"
        />
        <path
          d="M277.88,415.8c8.68,3.62,45.53,17.69,46.91,4.88l-1.64-71.39-56,2.3s.27,4.4.34,12.24c.11,12.21-4.91,25.75-9.53,39.82C257.48,405.13,276.45,415.2,277.88,415.8Z"
          fill="#dba795"
        />
        <path
          d="M324.14,392.25l-.23-10s-33.43-4.34-43.11-17.59C280.8,364.66,286.07,386.82,324.14,392.25Z"
          fill="#9e695c"
          opacity={0.2}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M268.77,351.53s12.79-.63,16.39-12.25c0-.16,15.89-64,38.42-64.28,26.69-.27,38.08,7.9,40.86,34,1.18,11.07,6.5,15.36,11.76,20.74a3.44,3.44,0,0,1-3.11,5.64l-3.88-.12a1.64,1.64,0,0,0-1.69,1.51c-1.18,14.83-8,35.45-12.74,39.11-2.92,2.27-14.06,5.62-24.46,6.28C290.5,384.66,268.77,351.53,268.77,351.53Z"
          fill="#dba795"
        />
        <path
          d="M355.08,322.87a2.08,2.08,0,0,1-3.24.56,3.12,3.12,0,0,1-.54-3.86,2.08,2.08,0,0,1,3.24-.56A3.14,3.14,0,0,1,355.08,322.87Z"
          fill="#382632"
        />
        <path
          d="M251.58,257.64c10.76-15.13,29.45-21.87,53.4-19.23,0,0,26.21,4.39,36.11,4.58.23,0,7.8,32,7.8,32a59.2,59.2,0,0,0-17,10.71c-6.89,6.18-11.49,19.65-12.25,26.46-.26,2.34-.41,5.45-.46,7.62v.44c-5.94,9.22-10.28.43-10.4.47,0-1.22,0-2.35,0-3.65-.05-.12,0-.27-.06-.4s-10.83,4.53-11.64,11c-2.45,19.27-18.14,37.49-27.85,37.5-21.34,0-19.47-30.49-29.1-55.56C232.47,289.48,240.85,272.73,251.58,257.64Z"
          fill="#061a47"
        />
        <path
          d="M287.48,321.26a10.34,10.34,0,0,0,12.11,8.43,11.08,11.08,0,0,0,9.3-11.85c-.39-6.19-5.19-11-10.71-10.59C288.08,308.08,286.46,315.37,287.48,321.26Z"
          fill="#dba795"
        />
        <path
          d="M296,319.19a2.64,2.64,0,0,1,1.74-2.05,3.64,3.64,0,0,1,1.43-.18,6.73,6.73,0,0,0-2.24-2.72c-.49-.36,0-1.18.49-.81a7.69,7.69,0,0,1,2.75,3.41,9.07,9.07,0,0,1,.3,4.79c-.09.59-1,.34-.93-.25a8.68,8.68,0,0,0-.07-3.48,4.5,4.5,0,0,0-.64,0l-.21,0h-.08l-.36.08-.14,0-.07,0h0l-.26.14-.12.07h0a.1.1,0,0,1-.05,0l-.2.21,0,0-.06.09a1.49,1.49,0,0,0-.14.24l0,0a.49.49,0,0,0,0,.11,1.19,1.19,0,0,0-.07.27.3.3,0,0,0,0,.1.56.56,0,0,0,0,.07,2.62,2.62,0,0,0,0,.28,1.94,1.94,0,0,0,0,.24.06.06,0,0,0,0,0l0,.16a1.71,1.71,0,0,0,.09.3s0,.09.05.13c0-.11,0,.05,0,.07s.1.18.16.27l.08.12s0,0,0,0l.06.08a.47.47,0,0,1,0,.66.49.49,0,0,1-.68,0A3.2,3.2,0,0,1,296,319.19Z"
          fill="#9e695c"
          opacity={0.5}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M357,274.16c7.84-5,12.59-12.87,11.4-23.33-.75-6.63-1.55-16.15-11.43-18.69-4-1-19.29-15.36-31.33-13.47-10.81,1.69-17.2,8.75-28.72,11.52-17.82,4.27-26.69,10.25-27.33,16.76s3,12.06-1.53,20.28c-5.24,9.56-10.07,11-12.1,18.56-1.09,4,1.64,4.5,6.75,18.14,3.85,10.29,1.43,17.44,4.88,19,6.89,3.17,11.09-6.25,17.39-7.55,8.16-1.69,14.66-5.89,15.32-6.81,4.53-6.34-3.06-13.61.76-17.56,4.23-4.37,14.09,4,28.2.39,8.72-2.23,19.62-2,22-4.16C359.22,280.31,352,277.4,357,274.16Z"
          fill="#02594f"
        />
        <path
          d="M319.25,318.88l23.49-1.42a18.06,18.06,0,0,0,0,5.4c1.15,8.06,7.26,13.87,13.63,13,5.91-.85,10-7.2,9.61-14.56l2.47-.35c-.39-.88-1-1.77-1.39-2.46l-1.41.17c-1.47-7.56-7.34-12.9-13.45-12-4.15.59-7.38,3.9-8.82,8.36l-24,1.46Zm25.5,3.69c-.94-6.62,2.55-12.62,7.78-13.36s10.26,4,11.2,10.65-2.54,12.62-7.77,13.37S345.7,329.19,344.75,322.57Z"
          fill="#f4e2ca"
        />
        <g clipPath="url(#clip-path)">
          <path
            d="M262.93,390.11s52.87,40.54,68.32,75.08c17.17,38.39,37.45,56.27,42.28,95.46,6.91,56.15,12.78,68.08,18.63,125,7.33,71.22,11.95,99.94,20.91,132.17,0,0-62.37,15.95-111.36,16-85.3,0-96.07-31.31-96.07-31.31,3.34-38.83,2.13-61.31,2.88-144.09.65-71.25,3.7-93.6,8.16-168.89C218.86,452.72,218.67,407.31,262.93,390.11Z"
            fill="#f15931"
          />
          <g opacity={0.15}>
            <path
              d="M335,433.18c-3.71,5.28-9,10-15.77,10.17a1.07,1.07,0,0,1,0-2.14c6-.12,10.67-4.47,13.93-9.11.79-1.11,2.64-.05,1.84,1.08Z"
              fill="#281a24"
            />
          </g>
          <path
            d="M340.14,774.15a5,5,0,0,1-1.57,1.57c-.62.49-1.26.95-1.91,1.39a32.84,32.84,0,0,1-3.91,2.23,1.07,1.07,0,0,1-1.08-1.84,32.9,32.9,0,0,0,3.7-2.1c.58-.38,1.15-.78,1.71-1.21.22-.16.43-.32.67-.52s.25-.21.37-.33.13-.16.09-.1.09-.17.09-.17a1.08,1.08,0,0,1,1.46-.38,1.09,1.09,0,0,1,.38,1.46Z"
            fill="#c4432d"
          />
          <path
            d="M300.33,492.71a201.8,201.8,0,0,1-38,6.9q-9.72.81-19.5.65c-5.52-.09-12.36.41-17.57-1.75-1.46-.6-.82-3,.66-2.4,5.2,2.15,12.06,1.6,17.61,1.67,6.27.08,12.55-.14,18.8-.66a198.76,198.76,0,0,0,37.33-6.81,1.25,1.25,0,0,1,.67,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M305.24,555.21c-12.62,4.08-27,4.71-40.13,5a231.13,231.13,0,0,1-41.37-2.87c-1.58-.25-.91-2.65.66-2.4a227.43,227.43,0,0,0,40.71,2.77c13-.29,27-.9,39.47-4.91,1.53-.5,2.19,1.91.66,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M312,615.28a236.59,236.59,0,0,1-85.24,9c-1.59-.12-1.61-2.62,0-2.49a235,235,0,0,0,84.58-8.86,1.25,1.25,0,0,1,.66,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M321.68,679.79a314.3,314.3,0,0,1-82.85,12.81,1.25,1.25,0,0,1,0-2.49A311.86,311.86,0,0,0,321,677.39a1.25,1.25,0,0,1,.66,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M330.8,730.63a216.28,216.28,0,0,1-73.3,13.81,1.25,1.25,0,0,1,0-2.49,214.48,214.48,0,0,0,72.64-13.72c1.5-.57,2.15,1.84.66,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M407.27,782.06c-31,13.18-64.49,17.31-98,17.91-34.86.62-70.31-.92-103.87-11.06a1.25,1.25,0,0,1,.66-2.41c32.36,9.78,66.37,11.42,100,11,34.07-.4,68.32-4.19,99.93-17.62,1.46-.62,2.73,1.53,1.26,2.16Z"
            fill="#f9f5ec"
          />
          <path
            d="M398,737.15c-20.67,5.76-42.15,7-63.49,7.65-1.61.06-1.6-2.44,0-2.49,21.12-.7,42.37-1.86,62.83-7.57a1.25,1.25,0,0,1,.66,2.41Z"
            fill="#f9f5ec"
          />
          <path
            d="M254.78,743.21a164.75,164.75,0,0,1-47.4-4.46c-1.56-.38-.9-2.78.66-2.4a162.32,162.32,0,0,0,46.74,4.37c1.61-.08,1.6,2.41,0,2.49Z"
            fill="#f9f5ec"
          />
          <path
            d="M393.57,685.85a346.7,346.7,0,0,1-68.43,7.5,1.25,1.25,0,0,1,0-2.49,343.67,343.67,0,0,0,67.76-7.41c1.57-.33,2.24,2.07.67,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M238.84,697.29a132.6,132.6,0,0,1-33.07-.48c-1.59-.22-.91-2.62.66-2.4a130.67,130.67,0,0,0,32.41.39c1.59-.18,1.58,2.32,0,2.49Z"
            fill="#f9f5ec"
          />
          <path
            d="M384.61,623.2a451.62,451.62,0,0,1-68.81,10.57c-1.6.12-1.59-2.37,0-2.49A445.69,445.69,0,0,0,384,620.79c1.56-.36,2.22,2,.66,2.41Z"
            fill="#f9f5ec"
          />
          <path
            d="M227.89,640.56A61,61,0,0,1,209,641.74c-1.58-.15-1.59-2.64,0-2.49a58.82,58.82,0,0,0,18.24-1.09c1.57-.34,2.23,2.06.67,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M378,574.22c-10.94,3.1-21.88,5.94-33.17,7.45-11.75,1.56-23.6,2.07-35.43,2.57-1.61.07-1.6-2.43,0-2.49,11.39-.48,22.81-1,34.13-2.4,11.51-1.48,22.66-4.38,33.81-7.54a1.25,1.25,0,0,1,.66,2.41Z"
            fill="#f9f5ec"
          />
          <path
            d="M223.29,587.83q-6.56.28-13.12,0c-1.6-.06-1.61-2.55,0-2.49q6.56.25,13.12,0c1.61-.08,1.6,2.42,0,2.49Z"
            fill="#f9f5ec"
          />
          <path
            d="M360.44,515.66a206.61,206.61,0,0,1-56.29,11.2c-1.61.1-1.6-2.4,0-2.49a204,204,0,0,0,55.62-11.11c1.52-.53,2.17,1.88.67,2.4Z"
            fill="#f9f5ec"
          />
          <path
            d="M222.31,532.86a38.68,38.68,0,0,1-8.59-.56,1.24,1.24,0,1,1,.66-2.4,36.18,36.18,0,0,0,7.93.47,1.25,1.25,0,0,1,1.25,1.24,1.28,1.28,0,0,1-1.25,1.25Z"
            fill="#f9f5ec"
          />
          <path
            d="M329.94,450.25a130.7,130.7,0,0,1-15.3,11,76.82,76.82,0,0,1-16.49,8.61c-1.52.53-2.17-1.88-.66-2.4a74,74,0,0,0,15.89-8.37,125,125,0,0,0,14.8-10.62c1.2-1.06,3,.7,1.76,1.76Z"
            fill="#f9f5ec"
          />
          <path
            d="M230.79,450a32.51,32.51,0,0,1-11.28-1.67,1.28,1.28,0,0,1-.87-1.53,1.26,1.26,0,0,1,1.54-.87,30.33,30.33,0,0,0,10.61,1.57c1.61-.05,1.61,2.45,0,2.5Z"
            fill="#f9f5ec"
          />
          <path
            d="M237.79,686.55c-3.52,22.89-3.78,46.05-3.66,69.15.05,11.53.54,23.15-1.09,34.6-1.58,11.08-4.64,21.82-4.68,33.1a1.25,1.25,0,0,1-2.49,0c0-12.15,3.57-23.68,5-35.66,1.38-11.45.78-23.1.73-34.61-.08-22.48.34-45,3.77-67.24.24-1.58,2.64-.91,2.4.66Z"
            fill="#f9faec"
          />
          <path
            d="M283,786.47c-2.86,16.2-.27,32.24,1.61,48.39.19,1.59-2.3,1.57-2.49,0-1.92-16.41-4.43-32.6-1.52-49.05.28-1.58,2.68-.91,2.4.66Z"
            fill="#f9faec"
          />
          <path
            d="M294.27,408.35c5.59,26.74,17.13,51.46,26.35,77,9.58,26.57,14.78,54.23,19.15,82,9,57,13.93,114.62,17.41,172.22,2,33.14,3.53,66.3,5.05,99.46.07,1.6-2.42,1.6-2.5,0l-.48-10.43c-.08-1.6,2.42-1.6,2.49,0,.16,3.48.32,7,.49,10.43h-2.5c-3.38-73.84-6.76-147.77-15.52-221.21-4.37-36.69-9-74.09-18.92-109.78C316,474.45,299,443.34,291.87,409c-.33-1.56,2.07-2.23,2.4-.66Z"
            fill="#f9faec"
          />
          <path
            d="M400.87,824.44q.35-63.63.67-127.27a1.25,1.25,0,0,1,2.5,0q-.35,63.63-.67,127.27a1.25,1.25,0,0,1-2.5,0Z"
            fill="#f9faec"
          />
          <path
            d="M310,791.7c-9.66-2.77-10.12-21.41-11.87-29.23-3.54-15.84-6.75-31.75-9.73-47.7-6.29-33.64-11.55-67.46-16.73-101.29q-7.43-48.54-14.84-97.09c-4.54-29.79-9-60.09-1.26-89.75a1.25,1.25,0,0,1,2.4.66c-8,30.88-2.7,62.45,2,93.4l13.29,87c4.56,29.81,9.14,59.63,14.4,89.33,2.63,14.84,5.42,29.65,8.47,44.42q2.44,11.93,5.14,23.8c1.38,6.06,2.24,22,9.36,24.09a1.25,1.25,0,0,1-.66,2.4Z"
            fill="#f9faec"
          />
          <path
            d="M270.88,417c18.5,19.78,26.56,45.76,30.07,72.13,4,30.28,4.54,61,7.85,91.4,7.08,64.77,19.11,128.86,31.45,192.8.26,1.34-1.8,1.92-2.06.57-11.5-59.6-22.72-119.32-29.95-179.61-3.63-30.36-5.17-60.8-7.91-91.23s-9.45-61.54-31-84.55c-.94-1,.57-2.52,1.51-1.51Z"
            fill="#c4432d"
          />
          <path
            d="M231.94,464.52c-7.37,26.29-8.3,53.47-8,80.61.35,27.43,1.09,54.94,3.81,82.25,2.76,27.69,7.84,55.13,16.83,81.51,8.49,24.88,18.8,49.1,28.13,73.67.49,1.29-1.58,1.84-2.06.57-9.52-25.07-20.12-49.78-28.65-75.21-8.76-26.08-13.66-53.21-16.39-80.54-2.77-27.85-3.51-55.91-3.82-83.88-.3-26.8.78-53.62,8-79.55a1.07,1.07,0,0,1,2.06.57Z"
            fill="#c4432d"
          />
          <path
            d="M287.09,787.22a67.71,67.71,0,0,1-15.66-3.35c-1.29-.44-.73-2.51.57-2.06a65.6,65.6,0,0,0,15.09,3.28c1.36.12,1.37,2.26,0,2.13Z"
            fill="#c4432d"
          />
        </g>
        <path
          d="M331.05,778.08c1.56,3.48,2.7,6.37,8.08,16.72,8.7,16.73,16.82,25.62,15.31,27.46-3,3.64-14.66-3.18-18.07-7.24,0,0,.57,8,.8,20.31.19,10.58-1.48,21.32-4.49,21.76-1.88.28-5.32-3.17-5.32-3.17-.44,2.68-2.63,6.37-4.61,6.4-4.38,0-5.92-6.34-5.92-6.34-1.26,2.66-4,4.81-6.13,4.44-4.83-.84-5.54-12.52-5.54-12.52a5.47,5.47,0,0,1-3.25,2.62c-3.61.66-5.38-7.59-6.54-16.78-.73-5.83-2.69-12.51-3.69-24.8-1.1-13.62-3.55-20.73-3.55-20.73C307.51,788.52,331.05,778.08,331.05,778.08Z"
          fill="#dba795"
        />
        <g
          opacity={0.5}
          style={{
            mixBlendMode: "multiply",
          }}
        >
          <path
            d="M327.15,852.56c.88-5.63,2.12-11.43,1.18-17.11-.89-5.42-2.05-10.78-3.44-16.09a.55.55,0,0,1,1.06-.29,160.6,160.6,0,0,1,3.65,17.38c.78,5.36-.56,11.1-1.39,16.4-.11.7-1.17.4-1.06-.29Z"
            fill="#9e695c"
            opacity={0.2}
            style={{
              mixBlendMode: "multiply",
            }}
          />
        </g>
        <g
          opacity={0.5}
          style={{
            mixBlendMode: "multiply",
          }}
        >
          <path
            d="M316.58,852.79A65.74,65.74,0,0,0,314,824.34c-.21-.68.85-1,1.06-.29a66.45,66.45,0,0,1,2.6,28.74c-.09.69-1.19.7-1.1,0Z"
            fill="#9e695c"
            opacity={0.2}
            style={{
              mixBlendMode: "multiply",
            }}
          />
        </g>
        <g
          opacity={0.5}
          style={{
            mixBlendMode: "multiply",
          }}
        >
          <path
            d="M304.54,845.13a55.39,55.39,0,0,0-2.79-22.56c-.23-.66.83-1,1.05-.29a56,56,0,0,1,2.84,22.85c-.06.7-1.16.71-1.1,0Z"
            fill="#9e695c"
            opacity={0.2}
            style={{
              mixBlendMode: "multiply",
            }}
          />
        </g>
        <g opacity={0.15}>
          <path
            d="M336.64,435.94a25.79,25.79,0,0,1-16.09,9.35,1.12,1.12,0,0,1-1.32-.75,1.08,1.08,0,0,1,.75-1.31,24.1,24.1,0,0,0,15.15-8.8,1.07,1.07,0,0,1,1.51,0,1.09,1.09,0,0,1,0,1.51Z"
            fill="#281a24"
          />
        </g>
        <path
          d="M356,302.88c.94-.93.38-1.61-1.85-2.46a23.24,23.24,0,0,0-7.19-1.22c-5,0-8,2.47-6.55,2.23,2.46-.41,4.46-.51,9.38.19C352.45,302,355.35,303.51,356,302.88Z"
          fill="#052620"
        />
        <path
          d="M344.64,261.39a8.69,8.69,0,0,0-7.62,1.4c-2.48,1.66-4.18,4.15-5.88,6.55a23.77,23.77,0,0,1-6.28,6.52,19.2,19.2,0,0,1-8.14,3c-6.15.72-12.29-1.51-18.43-.44a13.22,13.22,0,0,0-10.82,10.78,12.92,12.92,0,0,1-1.52,5,18.54,18.54,0,0,1-3.48,3.76,29.69,29.69,0,0,1-8.8,5.3c-.59.23-.33,1.2.27,1a31.06,31.06,0,0,0,7.76-4.36c2.2-1.69,4.63-3.77,5.76-6.37a21.89,21.89,0,0,0,1.08-4.59,11.81,11.81,0,0,1,1.45-3.79,12,12,0,0,1,6.14-5.12c5.86-2.12,12.22,0,18.23,0a20.33,20.33,0,0,0,15.06-6.77c2.28-2.59,3.89-5.74,6.38-8.16,2.22-2.16,5.47-3.79,8.58-2.7.61.21.87-.76.26-1Z"
          fill="#097263"
        />
        <path
          d="M303,267.08a18.46,18.46,0,0,0-9.19,1.64c-1.48.61-2.92,1.3-4.35,2a28.39,28.39,0,0,0-3.66,2,11.5,11.5,0,0,0-2.89,2.72,12.83,12.83,0,0,0-1.72,3.87,24.62,24.62,0,0,1-1.48,4.2,9.78,9.78,0,0,1-2.39,3,15.85,15.85,0,0,1-8.14,3.35c-.64.09-.37,1.06.26,1a17.74,17.74,0,0,0,7.19-2.56,11.47,11.47,0,0,0,4.65-5.86c.5-1.38.82-2.81,1.33-4.18a9.06,9.06,0,0,1,2.4-3.6c2.14-1.93,5-3.12,7.61-4.3,3.26-1.48,6.75-2.68,10.38-2.24.64.07.64-.93,0-1Z"
          fill="#097263"
        />
      </g>
      <g id="Layer_14" data-name="Layer 14">
        <ellipse
          cx={355.54}
          cy={350.7}
          rx={3.02}
          ry={5.59}
          transform="translate(-58.89 629.36) rotate(-78.52)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
)

export default SvgConsentThreeAOneTwo
